import React, { Component } from 'react';
import moment from 'moment';

export default class TradesTable extends Component {
  static sort(data, props, isOrderAsc) {
    const isoDatePattern = /^\d{4}(-\d{2}){2}T\d{2}(:\d{2}){2}\.\d{3}/;

    const sorted = data.sort((a, b) => {
      const sortableProperty = props.find(p => a[p] !== b[p]);

      if (typeof sortableProperty !== 'undefined') {
        // Found a good property to sort by
        if (typeof a[sortableProperty] === 'string') {
          // Check if it looks like an ISO 8601 date before attempting to parse
          if (isoDatePattern.test(a[sortableProperty])) {
            const momentA = moment(a[sortableProperty]);
            if (momentA.isValid()) {
              return momentA - moment(b[sortableProperty]);
            }
          }

          return a[sortableProperty].localeCompare(b[sortableProperty]);
        }

        return a[sortableProperty] - b[sortableProperty];
      }

      // It should never come to this
      return JSON.stringify(a).localeCompare(JSON.stringify(b));
    });

    if (!isOrderAsc) sorted.reverse();

    return sorted;
  }

  render() {
    const { children, className } = this.props;
    return (
      <table className={`table ${className} table-striped table-hover`}>
        {children}
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Table/Table.js